module.exports = __webpack_public_path__ + "img/banner_left.2326b19f.jpg";